import React from 'react';
import { connect } from 'react-redux';

import { APP_NAME, STATIC_ROOT } from '../../../constants';
import { ENTERPRISE_CARD_NAME } from '../../../constants/ebon';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';

import './EnterpriseCardHowItWorks.scss';

class EnterpriseCardHowItWorks extends React.Component {
    renderSvg = () => {
        return <SvgComponent src={`${STATIC_ROOT}/check.svg`} width="26" height="20" />;
    };
    render() {
        const { i18n } = this.props;

        return (
            <div className="enterpriseCard-hiw">
                <div>
                    <img
                        src={`${STATIC_ROOT}/enterprisecard/enterprisecard.png`}
                        alt={APP_NAME}
                        width="400"
                        height="400"
                    />
                </div>
                <div>
                    <h3>{convertHtmlToReactDomWithParams(i18n.TITLE, ENTERPRISE_CARD_NAME)}</h3>
                    <p className="subtitle">
                        {convertHtmlToReactDomWithParams(i18n.SUBTITLE, ENTERPRISE_CARD_NAME)}
                    </p>
                    <div className="row">
                        <div>{this.renderSvg()}</div>
                        <p>{i18n.TEXT1}</p>
                    </div>
                    <div className="row">
                        <div>{this.renderSvg()}</div>
                        <p>{i18n.TEXT2}</p>
                    </div>
                    <div className="row">
                        <div>{this.renderSvg()}</div>
                        <p>{i18n.TEXT3}</p>
                    </div>
                    <div className="row">
                        <div>{this.renderSvg()}</div>
                        <p>{i18n.TEXT4}</p>
                    </div>
                    <div className="row">
                        <div>{this.renderSvg()}</div>
                        <p>{i18n.TEXT5}</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = state => ({
    i18n: state.i18n.page.MERCHANTCARD.ENTERPRISE_CARD_HOW_IT_WORKS
});

export default connect(mapStoreToProps)(EnterpriseCardHowItWorks);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/EnterpriseCardHowItWorks.js